import React, { Fragment } from "react"
import { RouteComponentProps } from "@reach/router"
import { sendPageTrackingEvent } from "../../services"
import { Navigation } from "../../components/"
import legalInfo from "./legalInfo.json"
import styles from "./LegalInfo.scss"

const renderArticleTerms = list => (
  <Fragment>
    {list.map(str => {
      if (str[0] === "-") {
        const purifiedStr = str.replace("-", "")
        return (
          <dd key={purifiedStr}>
            <li>{purifiedStr}</li>
          </dd>
        )
      }
      return <p key={str}>{str}</p>
    })}
  </Fragment>
)

const renderSubArticleParts = (subArticles, articleIndex) => (
  <div>
    <div id="subArticle" key={subArticles[0].title}>
      {subArticles.map(({ title, list }, i) => (
        <dd key={title}>
          <h4>{`${articleIndex}.${++i}: ${title}`}</h4>
          <div>{renderArticleTerms(list)}</div>
        </dd>
      ))}
    </div>
  </div>
)

const renderArticles = articles => (
  <div>
    {articles.map(({ title, list }, i) => {
      return (
        <div id="article" key={title}>
          <h3>{`Article ${++i}: ${title}`}</h3>
          <div>
            {list[0].title
              ? renderSubArticleParts(list, i)
              : renderArticleTerms(list)}
          </div>
        </div>
      )
    })}
  </div>
)

const LegalInfoPage = ({  }: RouteComponentProps) => {
  const { title, description, definition, articles } = legalInfo

  sendPageTrackingEvent("CGU")
  return (
    <Fragment>
      <Navigation animated={false} />
      <div className={styles.container}>
        <div>
          <h1>{title}</h1>
          <p>{description}</p>
          <h2>Definition</h2>
          <p>{definition.pre}</p>
          <dd>{renderArticleTerms(definition.list)}</dd>
          {renderArticles(articles)}
        </div>
      </div>
    </Fragment>
  )
}

export default LegalInfoPage
